import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-background">
      <h1 className="mt-20 text-center text-4xl font-medium">
        {t("error.pageNotFound")} 😔
      </h1>
    </div>
  );
};

export default NotFound;
